import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "blog-article-item__info" }
const _hoisted_2 = { class: "blog-article-item__title" }
const _hoisted_3 = { class: "blog-article-item__description" }
const _hoisted_4 = { class: "blog-article-item__date" }
const _hoisted_5 = { class: "blog-article-item__read-more" }
const _hoisted_6 = ["src", "height", "width"]

import { computed } from 'vue';
import { imageFit } from '@distancify/drapejs-storyblok';
import BubbleButtonComponent from '@/components/BubbleButtonComponent.vue';


const __default__ = {
  name: 'BlogArticleItem'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  article: {
    type: Object,
    required: true,
  }
},
  setup(__props) {

const props = __props



const image = computed(() => {
  if (!props.article.metaImage) return;
  return imageFit(props.article.metaImage, { width: 290, height: 350 });
})

const date = computed(() => {
  return (new Date(props.article.first_published_at)).toLocaleDateString('sv-SE');
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "blog-article-item",
    to: '/' + __props.article.full_slug
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.article.name), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.article.meta?.description), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(date)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BubbleButtonComponent, {
          to: '/' + __props.article.full_slug,
          label: 'Read more',
          style: 'light'
        }, null, 8, ["to"])
      ]),
      (_unref(image))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(image)?.filename,
            height: _unref(image).height,
            width: _unref(image).width,
            class: "blog-article-item__image"
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})